import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "Languages";

import { fetchTemplatesWizardStep } from "../../actions";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {}

  redirectUrl = (e) => {
    e.preventDefault();
    let { TemplatesWizardData } = this.props;

    let clicked_step = e.currentTarget.dataset.data_id;
    let current_step = this.props.TemplatesWizardStep;
    let clicked_stepArr = clicked_step.split("_");
    let current_stepArr = current_step.split("_");

    let overview =
      TemplatesWizardData &&
      TemplatesWizardData.resource &&
      TemplatesWizardData.resource.overview &&
      !_.isEmpty(TemplatesWizardData.resource.overview)
        ? TemplatesWizardData.resource.overview
        : {};
    let url =
      TemplatesWizardData &&
      TemplatesWizardData.resource &&
      TemplatesWizardData.resource.url &&
      !_.isEmpty(TemplatesWizardData.resource.url)
        ? TemplatesWizardData.resource.url
        : {};
    let theme =
      TemplatesWizardData &&
      TemplatesWizardData.resource &&
      TemplatesWizardData.resource.theme &&
      !_.isEmpty(TemplatesWizardData.resource.theme)
        ? TemplatesWizardData.resource.theme
        : {};
    let publish =
      TemplatesWizardData &&
      TemplatesWizardData.resource &&
      TemplatesWizardData.resource.publish &&
      !_.isEmpty(TemplatesWizardData.resource.publish)
        ? TemplatesWizardData.resource.publish
        : {};

    let { redeploy } = this.props;
    let redeployDomain =
      redeploy &&
      !_.isEmpty(redeploy) &&
      redeploy.redeploy &&
      redeploy.from == "domain"
        ? true
        : false;
    let redeployTheme =
      redeploy &&
      !_.isEmpty(redeploy) &&
      redeploy.redeploy &&
      redeploy.from == "theme"
        ? true
        : false;
    let redeployUpgrade =
      redeploy &&
      !_.isEmpty(redeploy) &&
      redeploy.redeploy &&
      redeploy.from == "upgrade"
        ? true
        : false;

    if (clicked_stepArr[1] < current_stepArr[1]) {
      this.props.fetchTemplatesWizardStep(clicked_step);
    } else if (
      (clicked_stepArr[1] > current_stepArr[1] &&
        !_.isEmpty(overview) &&
        !_.isEmpty(url) &&
        !_.isEmpty(theme) &&
        !_.isEmpty(publish)) ||
      redeployDomain ||
      redeployTheme ||
      redeployUpgrade
    ) {
      this.props.fetchTemplatesWizardStep(clicked_step);
    }

  
  };

  render() {
    let { TemplatesWizardStep, TemplatesWizardData } = this.props;

    let activeStep1 =
      TemplatesWizardStep == "step_1" ? "activestepColor" : "stepColor";
    let activeStep2 =
      TemplatesWizardStep == "step_2" ? "activestepColor" : "stepColor";
    let activeStep3 =
      TemplatesWizardStep == "step_3" ? "activestepColor" : "stepColor";
    let activeStep4 =
      TemplatesWizardStep == "step_4" ? "activestepColor" : "stepColor";

    let overviewIcon = "fa fa-exclamation-circle";
    let overviewStyle = "steps-not-filled";
    if (
      TemplatesWizardData &&
      TemplatesWizardData.resource &&
      TemplatesWizardData.resource.overview &&
      !_.isEmpty(TemplatesWizardData.resource.overview)
    ) {
      overviewIcon = "fa fa-check-circle";
      overviewStyle = "steps-filled";
    }

    let { redeploy, siteDetails } = this.props;
    let redeployDomain =
      redeploy &&
      !_.isEmpty(redeploy) &&
      redeploy.redeploy &&
      redeploy.from == "domain"
        ? true
        : false;

    let urlIcon = "fa fa-exclamation-circle";
    let urlStyle = "steps-not-filled";
    if (
      (TemplatesWizardData &&
        TemplatesWizardData.resource &&
        TemplatesWizardData.resource.url &&
        !_.isEmpty(TemplatesWizardData.resource.url)) ||
      redeployDomain ||
      (redeploy &&
        !_.isEmpty(redeploy) &&
        redeploy.redeploy &&
        redeploy.from != "domain" &&
        siteDetails &&
        siteDetails.resource &&
        !_.isEmpty(siteDetails.resource))
    ) {
      urlIcon = "fa fa-check-circle";
      urlStyle = "steps-filled";
    }

    let redeployTheme =
      redeploy &&
      !_.isEmpty(redeploy) &&
      redeploy.redeploy &&
      redeploy.from == "theme"
        ? true
        : false;

    let themeIcon = "fa fa-exclamation-circle";
    let themeStyle = "steps-not-filled";
    if (
      (TemplatesWizardData &&
        TemplatesWizardData.resource &&
        TemplatesWizardData.resource.theme &&
        !_.isEmpty(TemplatesWizardData.resource.theme)) ||
      (redeploy &&
        !_.isEmpty(redeploy) &&
        redeploy.redeploy &&
        redeploy.from != "theme" &&
        siteDetails &&
        siteDetails.resource &&
        !_.isEmpty(siteDetails.resource)) ||
      redeployTheme
    ) {
      themeIcon = "fa fa-check-circle";
      themeStyle = "steps-filled";
    }

    let redeployUpgrade =
      redeploy &&
      !_.isEmpty(redeploy) &&
      redeploy.redeploy &&
      redeploy.from == "upgrade"
        ? true
        : false;

    let publishIcon = "fa fa-exclamation-circle";
    let publisStyle = "steps-not-filled";
    if (
      (TemplatesWizardData &&
        TemplatesWizardData.resource &&
        TemplatesWizardData.resource.publish &&
        !_.isEmpty(TemplatesWizardData.resource.publish) &&
        TemplatesWizardData.resource.publish.purchasecredentials &&
        !_.isEmpty(TemplatesWizardData.resource.publish.purchasecredentials)) ||
      (redeploy &&
        !_.isEmpty(redeploy) &&
        redeploy.redeploy &&
        redeploy.from != "upgrade" &&
        siteDetails &&
        siteDetails.resource &&
        !_.isEmpty(siteDetails.resource)) ||
      redeployUpgrade
    ) {
      publishIcon = "fa fa-check-circle";
      publisStyle = "steps-filled";
    }
    // else if (urlDashboard && urlDashboard.url && urlDashboard.paidurl && urlDashboard.paymentgateway && urlDashboard.setting) {
    //     publishIcon = 'fa fa-check-circle';
    //     publisStyle = 'steps-filled';
    // }

    return (
      <div>
        <ul className="wizard_breadcrumb breadcrumb-ipad">
          <li>
            <a href="#" data-data_id="step_1" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${overviewIcon} ${overviewStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep1}>
                  {LocaleStrings.website_wizard_tab_1}
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" data-data_id="step_2" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${urlIcon} ${urlStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep2}>
                  {LocaleStrings.website_wizard_tab_2}
                </div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" data-data_id="step_3" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${themeIcon} ${themeStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep3}>
                  {LocaleStrings.website_wizard_tab_3}
                </div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" data-data_id="step_4" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${publishIcon} ${publisStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep4}>
                  {LocaleStrings.website_wizard_tab_4}
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    TemplatesWizardStep: state.TemplatesWizardStep,
    TemplatesWizardData: state.TemplatesWizardData,

    siteDetails: state.siteDetails,
    redeploy: state.redeploy,
  };
}
export default connect(mapStateToProps, { fetchTemplatesWizardStep })(
  Navigation
);
